(function () {
  'use strict';

  document.querySelectorAll('[data-bs-sticky-atc]').forEach(function (bar) {
    var targetButtonId = bar.dataset.targetButtonId;
    var targetButton = targetButtonId ? document.getElementById(targetButtonId) : null;
    if (!targetButton) return;

    var ctaButton = bar.querySelector('[data-bs-sticky-atc-cta]');
    var priceEl   = bar.querySelector('[data-bs-sticky-atc-price]');
    var ctaTextEl = bar.querySelector('[data-bs-sticky-atc-cta-text]');

    // ── Visibility: real button scrolled past × cart drawer closed ──────

    var scrolledPast = false;
    var drawerOpen    = false;

    function setVisible(visible) {
      bar.classList.toggle('bs-sticky-atc--visible', visible);
      bar.toggleAttribute('inert', !visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');

      // Reserve the bar's own height at the bottom of the page while
      // visible, so nothing underneath — including the 360 viewer's
      // slider further up the page — ends up covered or unreachable.
      document.body.style.paddingBottom = visible ? bar.offsetHeight + 'px' : '';
    }

    function updateVisibility() {
      setVisible(scrolledPast && !drawerOpen);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // isIntersecting alone doesn't say which direction — a button
        // still below the fold on initial load is also "not
        // intersecting". boundingClientRect.top < 0 is what confirms it
        // actually scrolled past above the viewport.
        scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        updateVisibility();
      }, { threshold: 0 }).observe(targetButton);
    }

    var cartOverlay = document.getElementById('bs-cart-overlay');
    if (cartOverlay) {
      drawerOpen = !cartOverlay.hasAttribute('hidden');
      new MutationObserver(function () {
        drawerOpen = !cartOverlay.hasAttribute('hidden');
        updateVisibility();
      }).observe(cartOverlay, { attributes: true, attributeFilter: ['hidden'] });
    }

    // ── Variant sync — a no-op today (this section is a single-SKU
    // product with no variant picker), wired up so the bar doesn't go
    // stale if a variant picker is ever added here.

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) return;

        if (priceEl && typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          priceEl.textContent = Shopify.formatMoney(variant.price, window.moneyFormat);
        }

        if (ctaButton) {
          if (variant.available) {
            ctaButton.removeAttribute('aria-disabled');
            if (ctaTextEl && window.variantStrings) ctaTextEl.textContent = window.variantStrings.addToCart;
          } else {
            ctaButton.setAttribute('aria-disabled', 'true');
            if (ctaTextEl && window.variantStrings) ctaTextEl.textContent = window.variantStrings.soldOut;
          }
        }
      });
    }

    // ── Click — reuses the main product-form via the button's form=""
    // attribute, no second <form> tag. Guards against double-submits
    // with its own aria-disabled flag, always reset via a finally-
    // equivalent: the pubsub success/error events below, or a timeout
    // fallback if neither ever fires.

    if (ctaButton) {
      var processingTimeout = null;

      function finishProcessing() {
        if (processingTimeout) { clearTimeout(processingTimeout); processingTimeout = null; }
        ctaButton.removeAttribute('aria-disabled');
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, finishProcessing);
        subscribe(PUB_SUB_EVENTS.cartError, finishProcessing);
      }

      ctaButton.addEventListener('click', function (e) {
        if (ctaButton.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          return;
        }
        ctaButton.setAttribute('aria-disabled', 'true');
        processingTimeout = setTimeout(finishProcessing, 8000);
      });
    }
  });
})();
